import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { communicationsStatusPageRoute } from '@atlassian/jira-router-routes-communications-routes/src/communicationsStatusPageRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { StatusPageEntryPoint } from './ui/status-page/StatusPageEntryPoint.tsx';

export const communicationsStatusPageRouteEntry = createEntry(
	communicationsStatusPageRoute,
	() => ({
		group: 'communications',
		navigation: {
			menuId: MENU_ID.STATUS_PAGE_MANAGE,
			sidebar: AsyncSidebarServicedesk,
		},
		entryPoint: () => {
			return fg('communications_status_page_manage_platform') ? StatusPageEntryPoint : undefined;
		},
		resources: [...getNavigationResources()],
		bifrost: {
			bifrostGroup: 'shell-only',
			bundling: {
				packageName:
					'@atlassian/jira-router-routes-communications-entries/src/communicationsStatusPageRouteEntry.tsx',
				whichExportToUse: 'communicationsStatusPageRouteEntry',
			},
			enabled: true,
		},
	}),
);
